import { LegalEntityCountry } from '@seapoint/server/enums';
import { useSearchParams } from 'react-router';
import { useData } from '../../../../contexts/data-context/use-data';
import { ErrorSection } from '../../../../design-system/error-section/error-section';
import { LoadingSection } from '../../../../design-system/loading/loading';
import { OpenAccountSection } from './components/open-account-section';

export const OpenAccountPage = () => {
  const { data, isLoading: isLoadingData, error: dataError } = useData();
  const [searchParams] = useSearchParams();

  if (isLoadingData) {
    return <LoadingSection text="Loading..." />;
  }

  if (!data) {
    return <ErrorSection error={dataError} />;
  }

  // Scape hatch when we need to link demo data in production or without having to link an account first
  const demoSearchParam = searchParams.get('demo');
  const demoDataConfig =
    demoSearchParam === 'true'
      ? {
          isEnabled: true as const,
          companyId: data?.companies[0].id,
        }
      : {
          isEnabled: false as const,
        };

  return (
    <OpenAccountSection
      isLegalEntityInUk={data.companies[0].legalEntity.country === LegalEntityCountry.GB}
      demoDataConfig={demoDataConfig}
    />
  );
};
